import { frequencyToCron, parseScheduleDateFilter } from "../../../../models/looker/schedule";
import axios from "axios";
export default class Delivery {
    constructor(sdk) {
        this.sdk = sdk;
        // where content related to the delivery explore in the report center should be saved
        this.folderPath = "report-center/explore_conversion_report_builder";
    }
    async runSchedule(scheduleConfig, runOnce = false) {
        const url = `${this.sdk.urls.burnsBaseUrl}/looker/schedules${runOnce ? "?run_once=true" : ""}`;
        try {
            return axios
                .post(url, scheduleConfig, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then((res) => res.data);
        }
        catch (e) {
            console.error(e);
            if (runOnce) {
                throw new Error("Failed to test run Looker schedule");
            }
            throw new Error("Failed to save Looker schedule");
        }
    }
    async schedule(settings, filters) {
        const scheduleConfig = await this.buildScheduleConfig(settings, filters);
        return this.runSchedule(scheduleConfig);
    }
    async test(settings, filters) {
        const scheduleConfig = await this.buildScheduleConfig(settings, filters);
        return this.runSchedule(scheduleConfig, true);
    }
    async reportBuilderSend(reportName, qid, deliveryEmails) {
        const queryForSlug = await this.sdk.looker.query.createFromSlug(qid);
        const query = await this.sdk.looker.query.create({
            ...queryForSlug,
            // filters can't be undefined, so we need to provide an empty object if there are none
            filters: {
                ...queryForSlug.filters
            },
            // fields can't be null, so we need to provide an empty object if there are none
            fields: queryForSlug.fields || []
        });
        const sendConfig = {
            folder_path: "report-builder/send",
            name: reportName,
            /*
             * Cron tab must be provided as Looker just uses the test schedule functionality
             * to send reports. Because we're essentially testing the scheduled delivery of
             * a report, the schedule must have a crontab defining its delivery frequency.
             * However, it's not actually used and its value doesn't matter.
             */
            crontab: frequencyToCron({
                date: "daily",
                time: "0:0"
            }),
            scheduled_plan_destination: this.formatEmailsForSchedule(deliveryEmails, "csv"),
            query_id: query.id
        };
        return this.runSchedule(sendConfig, true);
    }
    async buildScheduleConfig(settings, filters) {
        const queryForSlug = await this.sdk.looker.query.createFromSlug(filters.qid);
        const { id: scheduleQueryId } = await this.sdk.looker.query.create({
            ...queryForSlug,
            // remove filter config from the query so that it doesn't override the selected filter value in the schedule's underlying look
            filter_config: undefined,
            filters: {
                ...queryForSlug.filters,
                "explore_conversion.flt_analysis_interval": parseScheduleDateFilter(filters.date)
            },
            fields: queryForSlug.fields || []
        });
        return {
            folder_path: this.folderPath,
            name: settings.name,
            crontab: frequencyToCron(settings.frequency),
            scheduled_plan_destination: this.formatEmailsForSchedule(settings.emails, settings.format),
            query_id: scheduleQueryId
        };
    }
    formatEmailsForSchedule(emails, format) {
        return emails.map((recipient) => ({
            format: format,
            apply_formatting: false,
            apply_vis: false,
            address: recipient,
            type: "email"
        }));
    }
}
//# sourceMappingURL=delivery.js.map